import React from 'react';
import styles from './VisionMission.module.css';

function VisionMission() {
  return (
    <section className={styles.visionMission}>
      <h2>Vision</h2>
      <p>
        Equipping learners to excel in life by addressing their academic, physical, spiritual, and inter social development needs.
      </p>
      <h2>Mission</h2>
      <p>
        To provide quality, affordable, and holistic education experience to develop the next generation of Africa’s servant leaders.
      </p>
    </section>
  );
}

export default VisionMission;
